import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    remitAccount: Yup.number()
      .required()
      .typeError("US.COLLECTION.VALIDATIONS:REQUIRED.INVALID_ACCOUNT_NO"),
  });
};
